import { Suspense } from 'react'
import { createPortal } from 'react-dom'
import ReactDOM from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import { pipe } from 'remeda'
import { CartDrawer } from '@components/CartDrawer/CartDrawer'
import { CartPage } from '@components/CartPage/CartPage'
import Header from '@components/Header'
import renderLiquidLinks from '@components/Header/utils/renderLiquidLinks'
import { WishlistDrawer } from '@components/WishlistDrawer/WishlistDrawer'
import {
  withApollo,
  withErrorBoundary,
  withExchangeRates,
  withI18next,
  withStaffPickImage,
  withTheme,
} from '@hocs'
import type { CartDrawerData } from '@velasca/types'
import { ErrorFallback } from '@velasca/ui/error-fallback'
import { parseJSONSafe } from '@velasca/utils/parse-json-safe'
import { withWishlist } from '../hocs/withWishlist'

const cartPageEl = document.getElementById('cart-page')

const complementaryProductsSettingsEl = document.getElementById(
  'complementary-products-settings-json',
)
const complementaryProductsSettingsJson = complementaryProductsSettingsEl
  ? parseJSONSafe(complementaryProductsSettingsEl.innerText)
  : {}

export const renderCartPageApp = (
  cartDrawerData: CartDrawerData,
  headerEl: HTMLElement | null,
  headerData: any,
  promotionalBannerData: any,
  minisearchData: any,
) => {
  if (cartPageEl) {
    const CartPageApp = () => {
      return (
        <>
          <CartDrawer
            emptyCartCtas={cartDrawerData?.ctas || []}
            editorialSuggestedProductsDesktopImage={
              cartDrawerData?.editorial?.suggestedProductsDesktopImage
            }
          />
          <WishlistDrawer />
          {headerEl &&
            createPortal(
              <Header
                sticky
                reduced
                promotionalBanner={promotionalBannerData || {}}
                miscHeaderData={headerData?.miscData}
                minisearch={minisearchData}
                lowerMenu={headerData?.mobileOnlyNav}
                menu={
                  renderLiquidLinks(
                    headerData?.nav,
                    headerData?.miscData?.liquidLinks,
                  ) ?? undefined
                }
              />,
              headerEl,
            )}
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Suspense fallback={null}>
              <CartPage
                complementaryProductSettings={complementaryProductsSettingsJson}
                emptyCartCtas={cartDrawerData?.ctas || []}
              />
            </Suspense>
          </ErrorBoundary>
        </>
      )
    }

    const CartPageAppWrapper = pipe(
      CartPageApp,
      withStaffPickImage,
      withExchangeRates,
      withWishlist,
      withI18next,
      withApollo,
      withErrorBoundary,
      withTheme,
    )

    ReactDOM.createRoot(cartPageEl).render(<CartPageAppWrapper />)
  }
}
